import React from 'react';

import type { ListType } from '~/components-ds/ReviewList';
import ReviewList from '~/components-ds/ReviewList';
import { COVER_DETAILS_TAX_AUDIT_ROUTE } from '~/constants/routes';
import { useAppContent, useCoverDetails } from '~/hooks';
import { Cover } from '~/types/cover';
import { CurrencyFormat, currencyFormatter } from '~/utils/currencyFormatter';

interface ReviewTaxAuditProps {}

const ReviewTaxAudit = (_: ReviewTaxAuditProps) => {
  const { getTextContent } = useAppContent({ basePath: 'dsme.review.fields.taxAudit' });

  const { taxAudit } = useCoverDetails();
  const reviewList = [
    {
      label: getTextContent('sumInsured'),
      data: currencyFormatter(taxAudit?.sumInsured, CurrencyFormat.Comma),
    },
  ];

  return (
    <ReviewList
      list={
        reviewList.reduce(
          (prev, curr, idx) => ({
            ...prev,
            [String(idx)]: {
              id: idx,
              name: curr.label,
              label: curr.label,
              value: curr.data,
            },
          }),
          {}
        ) as ListType
      }
      title={Cover.TaxAudit}
      editRoute={COVER_DETAILS_TAX_AUDIT_ROUTE}
    />
  );
};

export default ReviewTaxAudit;
